/**
 * @generated SignedSource<<8a5be52bf2a0c5890570e2234deb934f>>
 * @relayHash 70c5cbd47116df92d038a359e0a381dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 25f49fe0ada85ace5a4512fd45e0bde5c33a1a1007a90ef950b6cf4cfbc381bb

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type realtimeUpdater_issueUpdated_Subscription$variables = {
  cloudId: string;
  projectId: string;
};
export type realtimeUpdater_issueUpdated_Subscription$data = {
  readonly jira: {
    readonly onIssueUpdatedByProjectNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type realtimeUpdater_issueUpdated_Subscription = {
  response: realtimeUpdater_issueUpdated_Subscription$data;
  variables: realtimeUpdater_issueUpdated_Subscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
          }
        ],
        "concreteType": "JiraIssueUpdatedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueUpdatedByProjectNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "realtimeUpdater_issueUpdated_Subscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "realtimeUpdater_issueUpdated_Subscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "25f49fe0ada85ace5a4512fd45e0bde5c33a1a1007a90ef950b6cf4cfbc381bb",
    "metadata": {},
    "name": "realtimeUpdater_issueUpdated_Subscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "04520c3372a5e618b1581cb15407d4b5";

export default node;
